import secondaryClientForm from "../secondary/BankClientCreationConfirmationActivationSchema";
import { employerOcupation, clientTypeId } from "../commons";


const form = {
    title: "Bank Client Creation Confirmation Activation",
    displayName: 'BankClientCreationConfirmationActivation',
    page: 'bank-client-creation-confirmation-activation',
    secondaryClientForm
};


form.schema = {
    title: "Creación de cliente JMMB Bank",
    type: "object",
    properties: {
        "tipoCliente": clientTypeId,
        // "enviarCorreoCliente": {
        //     "buttonText": "Enviar Correo a Cliente",
        //     subject: "¡Te damos la bienvenida a JMMB!",
        //     body: "¡TE DAMOS LA BIENVENIDA A LA FAMILIA JMMB! \n\n\n\n Estamos contentos porque contigo nuestro Grupo Banco sigue creciendo. \n\nNuestra cultura está basada en el amor incondicional teniendo tu mejor interés en nuestros corazones. Somos tu socio financiero brindándote de soluciones integrales e innovadoras que junto a nuestra asesoría personalizada te empoderarán para lograr tus sueños. \n\n\n Le pedimos que se tome unos minutos y llene la siguiente encuesta para evaluar su experiencia de vinculación con el grupo JMMB.",
        //     type: "null",
        // },
        // "EmployerOcupation": {
        //     title: "Ocupación del Empleado",
        //     type: "string",
        //     enum: employerOcupation ,
        //     enumNames: employerOcupation,
        // },
        
        // "ucsIndustryId": {
        //     title: "Industria (UCS)",
        //     type: "number",
        //     lookup: {
        //         api: 'ucs-ref-codes',
        //         params: { type: 'INDUSTRY' },
        //         resource: "Industrias",
        //         id: 'id',
        //         label: 'label'
        //     }
        // },
        // "ucsSectorId": {
        //     title: "Sector (UCS)",
        //     type: "number",
        //     lookup: {
        //         api: 'ucs-sectors',
        //         params: { industryId: { field: 'ucsIndustryId' } },
        //         resource: "Sectores",
        //         id: 'id',
        //         label: 'label'
        //     }
        // },
        // Corporate-only UCS Industry/Sector ref code selection (ticket 728-6-10).
        // Sector options depend on the selected industry (its parentID points to a sector);
        // when there is no match the endpoint returns every sector.
        
        "infCliUCS": {
            title: " ",
            description: "Informaciones Cliente UCS",
            type: "object",
            properties: {
                "cliUCS": {
                    title: "Crear cliente en UCS"
                },
                "numCliUCS": {
                    title: "Número de cliente en UCS",
                    type: "string"
                },
            },
            required: ["cliUCS", "numCliUCS"]

        },
        "infCliT24Banco": {
            title: " ",
            description: "Informaciones Cliente T24 Banco",
            type: "object",
            properties: {
                "cliT24SAFI": {
                    title: "Cliente creado en T24 Banco",
                    type: "boolean"
                },
                "numCliT24SAFI":
                {
                    title: "Número de cliente en T24 Banco",
                    type: "string"
                },
                "numCtaT24SAFI":
                {
                    title: "Número de cuenta en T24 Banco",
                    type: "string"
                },
            },
            required: []
        },
        "actCliT24": {
            title: " ",
            description: "Activación del Cliente en T24",
            type: "object",
            properties: {
                "pantConfT24": {
                    title: "Pantalla Confirmación T24",
                    type: "number"
                },
                "cliActivo": {
                    title: "Cliente activo en T24 Banco",
                    type: "boolean"
                }
            },
            required: []
        },
    }
}

form.uiSchema = {
    "ui:field": "HideObjectField",
    "ui:className": "hideObjectField_title",
    // "enviarCorreoCliente": { "ui:field": "SendEmail" },
    "tipoCliente": {
        "ui:readonly": true,
        "ui:widget": "radio",
        "ui:options": {
            inline: true
        },
        "ui:showIf": {
            "expr": "false", // Always hide this field, it's just for display in the review step.
            "debug": "testing"
        },
    },
    
    // "ucsIndustryId": {
    //     "akc:requiredIfVisible": true,
    //     "ui:field": "LookupFormField",
    //     "ui:showIf": {
    //         "expr": "tipoCliente = 2 or tipoCliente = 3",
    //     },
    //     // "joli:showAttr": { caseData: { "clients[0].clientTypeId": [2, 3] } },
    // },
    // "ucsSectorId": {
    //     "akc:requiredIfVisible": true,
    //     "ui:field": "LookupFormField",
    //     "ui:showIf": {
    //         "expr": "tipoCliente = 2 or tipoCliente = 3",
    //     },
    //     // "joli:showAttr": { caseData: { "clients[0].clientTypeId": [2, 3] } },
    // },
    // "EmployerOcupation": {
    //     "akc:requiredIfVisible": true,
    //     "ui:showIf": {
    //         "expr": "tipoCliente = 1 or tipoCliente = 4",
    //     },
    //     // "joli:showAttr": { caseData: { "clients[0].clientTypeId": [1, 4] } },
    // },
    "actCliT24": {
        "pantConfT24": { "ui:field": "FileField" },
    },
    "infCliUCS": {
        "cliUCS": {
            "ui:field": "CallUCSAPIButton",
        },
    },
}

form.objectMap = {
    // "clients[0].retailClientInvestorProfile.employerOcupation": "EmployerOcupation",
    // "clients[0].businessClientGeneralInfo.ucsIndustryId": "ucsIndustryId",
    // "clients[0].businessClientGeneralInfo.ucsSectorId": "ucsSectorId",
    "clients[0].retailClientInvestorProfile.wasCreatedInUSC": "infCliUCS.cliUCS",
    "clients[0].retailClientInvestorProfile.uscClientNumber": "infCliUCS.numCliUCS",
    "clients[0].retailClientInvestorProfile.clientCreatedT24Bank": "infCliT24Banco.cliT24SAFI",
    "clients[0].retailClientInvestorProfile.t24BankClientId": "infCliT24Banco.numCliT24SAFI",
    "clients[0].retailClientInvestorProfile.t24BankAccountNumber": "infCliT24Banco.numCtaT24SAFI",
    "clients[0].retailClientInvestorProfile.clientActivatedT24Bank": "actCliT24.cliActivo",
    "clients[0].retailClientInvestorProfile.t24ConfirmationFileId": "actCliT24.pantConfT24",
    "clients[0].clientTypeId": "tipoCliente",
}


export default form;